import styled from "styled-components";

export const ContactComponentMainDiv = styled.main``;

export const ContactComponentHeroMainDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 210px 40px 100px;
    align-items: center;
    justify-content: center;
  }
  .contact-container {
    display: flex;
    flex-flow: column;
    gap: 60px;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1;
    max-width: 1140px;
  }
  .contact-header-container {
    display: flex;
    flex-flow: column;
    gap: 24px;
    width: 100%;
    flex: 1;
    align-items: center;
    justify: center;

    max-width: 810px;
  }
  .contact-header-wrapper {
    display: flex;
    flex-flow: column;
    gap: 12px;
    width: 100%;

    flex: 1;
    align-items: center;
    justify: center;
  }
  .contact-header-text-wrapper {
    text-align: center;

    > h1 {
      font-size: 76px;
    }
    > p {
      font-size: 20px;
      font-weight: 400;
    }
  }
  .contact-form-container {
    width: 100%;
    flex: 1;
    background: #060606;
    border-radius: 16px;
    padding: 32px;
    display: flex;
    gap: 24px;
    align-items: stretch;
  }
  .contact-form-wrapper {
    width: 100%;
    flex: 1;
    display: flex;
    gap: 36px;
    border-radius: 16px;
    flex-flow: column;
  }
  .contact-form-input-container {
    width: 100%;
    flex: 1;
    display: flex;
    gap: 20px;
    flex-flow: column;
    border-bottom: 1px solid #f5f5f5;
    height: 46px;
    padding: 0 0 20px 0;
    transition: all 0.4s;
    &:focus-within {
      border-bottom: 1px solid  rgb(97, 150, 242);
    }
  }
  .contact-form-input-wrapper {
    width: 100%;
    flex: 1;
    height: 100%;
    font-size: 20px;
    background: transparent;
    border: none;
    outline: none;
    color: white;
    &::placeholder {
      color: #888;
      text-transform: capitalize;
      font-size: 20px;
    }
  }
  .contact-form-text-area-wrapper {
    font-family: inter;
    resize: none;
    &::-webkit-scrollbar {
      display: none;
    }

    scrollbar-width: none;

    &::placeholder {
      color: #888;
      text-transform: capitalize;
      font-size: 20px;
      font-family: inter;
    }
  }

  .contact-form-left {
    display: flex;
    flex-flow: column;
    gap: 32px;
  }
  .contact-form-bottom {
    display: flex;
    flex-flow: column;
    gap: 10px;
  }
  .contact-form-bottom-text-wrapper {
    > {
      font-size: 16px;
    }

    a {
      color:  rgb(97, 150, 242);
    }
  }
`;
export const ContactComponentContactDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 24px;
  width: 45%;
  justify-content: space-between;
  flex: 1;

  .contact-info-header-text-container {
    display: flex;
    gap: 10px;
    flex-flow: column;
  }
  .contact-info-header-text-wrapper {
    > p {
      font-size: 18px;
      font-family: inter;
    }
    > p,
    > h3 {
      color: inherit;
      transition: all 0.3s;
      > a {
        color: inherit;
        font-size: inherit;
      }
    }
    > h3 {
      font-size: 3em;
    }
    &:hover {
      color:  rgb(97, 150, 242);
    }
  }
  .contact-address-info-container {
    display: flex;
    flex-flow: column;
    gap: 46px;
    width: 100%;
  }
  .contact-address-info-wrapper {
    display: flex;
    flex-flow: column;
    gap: 8px;
    width: 100%;
  }
  .contact-address-info-text-wrapper {
    > p {
      font-size: 16px;
    }
  }
  .contact-address-info-address-text-wrapper {
    opacity: 0.4;
  }
  .contact-link-wrapper {
    display: flex;
    gap: 10px;
    align-items: center;
    cursor: pointer;
    transition: all 0.5s;
    &:hover {
      opacity: 0.9;
      .contact-icon-wrapper {
        > svg {
          transform: rotate(180deg);
        }
      }
      .contact-link-text-wrapper {
        transform: translateY(-27px);

        > p {
        }
      }
    }
  }
  .contact-address-link-container {
    display: flex;
    flex-flow: column;
    gap: 8px;
  }
  .contact-icon-wrapper {
    width: 20px;
    height: 20px;

    color:  rgb(97, 150, 242);
    > svg {
      transition: all 0.5s;

      transform: rotate(135deg);
      fill:  rgb(97, 150, 242);
      width: 20px;
      height: 20px;

      color:  rgb(97, 150, 242);
    }
  }
  .contact-link-text-wrapper {
    transition: all 0.3s;

    > p {
      font-size: 18px;
      font-weight: 500;
    }
  }
  .contact-link-text-container {
    display: flex;
    flex-flow: column;
    gap: 4px;
    height: 24px;
    overflow: hidden;
  }
  .contact-address-info-item-container {
    display: flex;
    flex-flow: column;
    gap: 8px;
  }
`;

export const ContactComponentTrustedDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 100px 40px;
    align-items: center;
    justify-content: center;
  }
  .contact-trusted-container {
    display: flex;
    flex-flow: column;
    gap: 32px;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex: 1;
    max-width: 1140px;
  }
  .contact-trusted-wrapper {
    width: 100%;
    flex: 1;
  }
  .contact-trusted-item-container {
    width: 150px;
    height: 60px;
    display: flex;
    align-items:center;
    gap:10px;
  }
  .contact-trusted-icon-wrapper {
    width: 32px;
    height: 32px;

    color:  rgb(97, 150, 242);
    > svg {
      transition: all 0.5s;

      transform: rotate(135deg);
      fill:  rgb(97, 150, 242);
      width: 32px;
      height: 32px;

      color:  rgb(97, 150, 242);
    }
  }
`;
